export const GET_TOTAL_MERCHANDISING_CATEGORIES_DATA =
  '[MERCHANDISING] GET_TOTAL_MERCHANDISING_CATEGORIES_DATA';
